import './style.css'
import { useRef } from 'react'
import useGame from "./stores/useGame"

export default function UI()
{
    const phase = useGame((state) => state.phase)
    const infoPanel = useGame((state) => state.infoPanel)
    const reset = useGame((state) => state.reset) 
     
        return <>

        { phase != 'rest' && <div className='blocker'></div>}

        <div className='banner-top'>
            <img src="./DSL_Logo_stackedonBLK_Transp_Web_120.png" className="image-wrap" onClick={()=>{window.open('https://www.darkstarlabs.io/')}}></img>
            <div className="action-card-row" onClick={()=>{window.open('https://www.darkstarlabs.io/contact')}}>
                <div className='text-button-row'>Talk to the team</div>
                <div className='dot'>?</div>    
            </div> 
        </div>

        <div id="p0" className='p'>
            <div className='heading'>Level-up your marketing with 3D <span style={{color: '#F2330D'}}>animations</span> and <span style={{color: '#F2330D'}}>interactive</span> content</div>
            <div className='body'>We partner with engineering companies to create content that helps <span style={{fontWeight: 800}}>visualise, explain,</span> and <span style={{fontWeight: 800}}>engage</span>.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div>

        <div id="p1" className='p'>
            <div className='heading'>Virtual Brand and Product Ecosystems</div>
            <div className='body'>Transform your website and trade show booth into a dynamic and engaging experience with product configurators and simulated product ecosystems.</div>
            <div className='body'>Imagine your audience intuitively exploring your products in 3D, customising features in real-time, and experiencing them in a simulated environment.</div>
            <div className='body'>This not only provides a memorable and informative experience but also captures valuable data and insights.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>    
        </div>

        <div id="p2" className='p'>
            <div className='heading'>The future of marketing is playable.</div>
            <div className='body'>If you already have 3D assets of your products, then building a virtual space for your audience to interact with them is the next logical step. Let us help you create a truly unforgettable experience that sets you apart.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div>
      
    </>
}